/**
 * VCDR Backend Public APIs
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { TenantRwrActivationDetails } from './tenantRwrActivationDetails';
import { EdrDeploymentRegion } from './edrDeploymentRegion';
import { RansomwareRecoveryDeploymentStatesEnum } from './ransomwareRecoveryDeploymentStatesEnum';


export interface TenantRwrDeploymentDetails { 
    activation_details?: TenantRwrActivationDetails;
    activation_status?: RansomwareRecoveryDeploymentStatesEnum;
    /**
     * List of EDR regions managed by Customer.
     */
    customer_managed_regions?: Array<EdrDeploymentRegion>;
    /**
     * List of EDR regions managed by VMware.
     */
    vmware_managed_regions?: Array<EdrDeploymentRegion>;
}
export namespace TenantRwrDeploymentDetails {
}


